// @flow
import React, { Suspense } from 'react';

import LoadingIndicator from '../../components/LoadingIndicator';

const InPlatformNotifications = React.lazy(() => import('./index'));

const InPlatformNotificationsLoadable = () => (
  <div>
    <Suspense fallback={<LoadingIndicator />}>
      <InPlatformNotifications />
    </Suspense>
  </div>
);

export default InPlatformNotificationsLoadable;
